module.exports = __webpack_public_path__ + "img/CZ07662645.fc29bc29.png";